import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import xlsx from 'xlsx';
import server from '../../../_api/backend';
import * as toast from '../../../_store/slice/toast';
import { Pagenation } from '../../../_component/pagenation';

export function AdminSampleBook() {
  const [items, setItems] = useState<any[]>([]);
  const dispatch = useDispatch();
  const [
    pageInfo = { total: 10, rowCount: 10, page: 1, totalPages: 1 },
    setPageInfo,
  ] = useState<any>();
  // const [meta, setMeta] = useState<any>({});
  // const [currentPage, setCurrentPage] = useState<number>(1);
  const [searchSelect, setSearchSelect] = useState<string>('bookname');
  const [searchText, setSearchText] = useState<string>('');
  const history = useHistory();
  const [excelLoading, setExcelLoading] = useState<string>('(준비중)');
  const [excelData, setExcelData] = useState<any>([
    {
      isbn: '',
      book: '',
      author: '',
      published: '',
      quantity: '',
      day: '',
      name: '',
      phone: '',
      email: '',
      college: '',
      department: '',
      address: '',
    },
  ]);
  const excelDataEmpty = [
    {
      isbn: '',
      book: '',
      author: '',
      published: '',
      quantity: '',
      day: '',
      name: '',
      phone: '',
      email: '',
      college: '',
      department: '',
      address: '',
    },
  ];

  // 주소창 강제이동 또는 관리자 권한이 없는 사용자 → 메인페이지 이동
  useEffect(() => {
    if (
      window.localStorage.getItem('token') === null ||
      window.localStorage.getItem('authority') !== 'A'
    ) {
      dispatch(toast.error({ message: '관리자 권한이 없습니다.' }));
      history.push('/');
    } else {
      getAllSampleBook();
    }
  }, []);

  const options = [
    {
      value: 'bookname',
      name: '도서명',
    },
    {
      value: 'college',
      name: '대학명',
    },
    {
      value: 'professor',
      name: '교수명',
    },
  ];

  // 전체 견본도서 리스트 불러오기 (API)
  const getAllSampleBook = async () => {
    if (searchText.length === 0) {
      await server
        .getAllSampleBook(pageInfo.page, pageInfo.rowCount)
        .then(async (payload) => {
          setItems(payload.items);
          // setMeta(payload.meta);
          const { meta } = payload;
          setPageInfo({
            total: meta.totalItems,
            rowCount: meta.itemsPerPage,
            page: meta.currentPage,
            totalPages: meta.totalPages,
          });
          await server
            .getAllSampleBook(1, payload.meta.totalItems)
            .then((payload2) => {
              if (payload2.items.length !== 0) {
                dataExcelInput(payload2);
              } else {
                setExcelData(excelDataEmpty);
                setExcelLoading('(준비완료)');
              }
            })
            .catch((error) => {
              console.log(error);
            });
        })
        .catch((error) => {
          console.log(error);
        });
    } else {
      switch (searchSelect) {
        case 'bookname':
          await server
            .searchSampleBook(1, pageInfo.rowCount, searchText, '', '')
            .then(async (payload) => {
              console.log('payload', payload);
              setItems(payload.items);
              // setMeta(payload.meta);
              console.log(' 검색 결과 후 payload ', payload);
              await server
                .searchSampleBook(1, payload.meta.totalItems, searchText, '', '')
                .then((payload2) => {
                  if (payload2.items.length !== 0) {
                    dataExcelInput(payload2);
                  } else {
                    setExcelData(excelDataEmpty);
                    setExcelLoading('(준비완료)');
                  }
                });
              const { meta } = payload;
              setPageInfo({
                total: meta.totalItems,
                rowCount: meta.itemsPerPage,
                page: meta.currentPage,
                totalPages: meta.totalPages,
              });
            })
            .catch((error) => {
              console.log('검색실패', error);
            });
          break;
        case 'college':
          await server
            .searchSampleBook(1, pageInfo.rowCount, '', searchText, '')
            .then(async (payload) => {
              setItems(payload.items);
              // setMeta(payload.meta);
              await server
                .searchSampleBook(1, payload.meta.totalItems, '', searchText, '')
                .then((payload2) => {
                  if (payload2.items.length !== 0) {
                    dataExcelInput(payload2);
                  } else {
                    setExcelData(excelDataEmpty);
                    setExcelLoading('(준비완료)');
                  }
                });
              const { meta } = payload;
              setPageInfo({
                total: meta.totalItems,
                rowCount: meta.itemsPerPage,
                page: meta.currentPage,
                totalPages: meta.totalPages,
              });
            })
            .catch((error) => {
              console.log('검색실패', error);
            });
          break;
        case 'professor':
          await server
            .searchSampleBook(1, pageInfo.rowCount, '', '', searchText)
            .then(async (payload) => {
              setItems(payload.items);
              // setMeta(payload.meta);
              await server
                .searchSampleBook(1, payload.meta.totalItems, '', '', searchText)
                .then((payload2) => {
                  if (payload2.items.length !== 0) {
                    dataExcelInput(payload2);
                  } else {
                    setExcelData(excelDataEmpty);
                    setExcelLoading('(준비완료)');
                  }
                });
              const { meta } = payload;
              setPageInfo({
                total: meta.totalItems,
                rowCount: meta.itemsPerPage,
                page: meta.currentPage,
                totalPages: meta.totalPages,
              });
            })
            .catch((error) => {
              console.log('검색실패', error);
            });
          break;
        default:
          break;
      }
    }
  };

  // 페이징 관련
  const onClickPage = async (pageParam: any) => {
    if (searchText.length !== 0) {
      switch (searchSelect) {
        case 'bookname':
          await server
            .searchSampleBook(pageParam.page, pageParam.rowCount, searchText, '', '')
            .then((payload) => {
              setItems(payload.items);
              // setMeta(payload.meta);
              const { meta } = payload;
              setPageInfo({
                total: meta.totalItems,
                rowCount: meta.itemsPerPage,
                page: meta.currentPage,
                totalPages: meta.totalPages,
              });
            })
            .catch((error) => {
              console.log('검색실패', error);
            });
          break;
        case 'college':
          await server
            .searchSampleBook(pageParam.page, pageParam.rowCount, '', searchText, '')
            .then((payload) => {
              setItems(payload.items);
              // setMeta(payload.meta);
              const { meta } = payload;
              setPageInfo({
                total: meta.totalItems,
                rowCount: meta.itemsPerPage,
                page: meta.currentPage,
                totalPages: meta.totalPages,
              });
            })
            .catch((error) => {
              console.log('검색실패', error);
            });
          break;
        case 'professor':
          await server
            .searchSampleBook(pageParam.page, pageParam.rowCount, '', '', searchText)
            .then((payload) => {
              setItems(payload.items);
              // setMeta(payload.meta);
              const { meta } = payload;
              setPageInfo({
                total: meta.totalItems,
                rowCount: meta.itemsPerPage,
                page: meta.currentPage,
                totalPages: meta.totalPages,
              });
            })
            .catch((error) => {
              console.log('검색실패', error);
            });
          break;
        default:
          break;
      }
    } else {
      await server
        .getAllSampleBook(pageParam.page, pageParam.rowCount)
        .then((payload) => {
          setItems(payload.items);
          // setMeta(payload.meta);
          const { meta } = payload;
          setPageInfo({
            total: meta.totalItems,
            rowCount: meta.itemsPerPage,
            page: meta.currentPage,
            totalPages: meta.totalPages,
          });
        })
        .catch((error) => {
          console.log(error);
        });
    }
  };

  // 삭제 버튼 클릭 시
  const onClickRemove = async (id: any) => {
    if (window.confirm('정말 삭제하시겠습니까?')) {
      await server
        .deleteSampleBook(id)
        .then((payload) => {
          if (!payload) {
            dispatch(toast.error({ message: '서버로부터 응답이 없습니다.' }));
          } else if (payload.code === 260 || payload.code === 500) {
            dispatch(toast.error({ message: '파라미터 오류' }));
          }
          getAllSampleBook();
          dispatch(toast.info({ message: '삭제되었습니다.' }));
        })
        .catch((error) => {
          console.log(error);
        });
    }
  };

  // 상태 변경 버튼 클릭 시
  const onClickStateUpdate = async (id: number) => {
    const i = items.find((state) => state.id === id);
    if (window.confirm('변경하시겠습니까?')) {
      if (i.state === 'wait') {
        i.state = 'ok';
      } else {
        i.state = 'wait';
      }
      await server
        .stateUpdateSampleBook(id, { state: i.state })
        .then((payload) => {
          if (!payload) {
            dispatch(toast.error({ message: '서버로부터 응답이 없습니다.' }));
          } else if (payload.code === 260 || payload.code === 500) {
            dispatch(toast.error({ message: '파라미터 오류' }));
          }
          getAllSampleBook();
        })
        .catch((error) => {
          console.log(error);
        });
    } else {
      console.log('변경 취소');
    }
  };

  // 데이터값
  const rowData = () => {
    return items.map((item: any) => (
      <ul className="row" key={item.id}>
        <li className="isbn">{item.isbn}</li>
        <li className="book-title">{item.book?.name}</li>
        <li className="author"> {item.book?.author} </li>
        <li className="published"> {new Date(item.book?.publicationDate).toLocaleDateString()} </li>
        <li className="quantity">{item.bookCount}</li>
        <li className="day">{new Date(item.modDate).toLocaleString()}</li>
        <li className="buttons">
          <span>{item.state}</span>
          <button
            type="button"
            onClick={() => {
              onClickStateUpdate(item.id);
            }}
          >
            변경
          </button>
          <button
            type="button"
            onClick={() => {
              onClickRemove(item.id);
            }}
          >
            삭제
          </button>
        </li>
        <ul className="ship-to">
          <li className="user-name">{item.writer?.name}</li>
          <li className="phone">{item.phone}</li>
          <li className="email">{item.email}</li>
          <li className="education">
            {item.college} {item.department}
          </li>
          <li className="address">
            [{item.writer.post}] {item.address}
          </li>
        </ul>
      </ul>
    ));
  };

  // 엑셀 라이브러리 불러오기
  const onClickExcel = async () => {
    const ws = xlsx.utils.json_to_sheet(excelData);
    const wb = xlsx.utils.book_new();
    [
      'ISBN',
      '도서명',
      '저자',
      '출판일',
      '수량',
      '요청일',
      '이름',
      '연락처',
      '이메일',
      '대학명',
      '학과명',
      '주소',
    ].forEach((x, idx) => {
      const cellAdd = xlsx.utils.encode_cell({ c: idx, r: 0 });
      ws[cellAdd].v = x;
    });
    xlsx.utils.book_append_sheet(wb, ws, 'sheet1');
    xlsx.writeFile(wb, 'sample-book.xlsx');
  };

  // 엑셀 데이터값 준비
  const dataExcelInput = (data: any) => {
    const dataArray = [];
    for (let i = 0; data.items.length > i; i++) {
      dataArray[i] = {
        isbn: data.items[i].isbn,
        book: data.items[i].book?.name,
        author: data.items[i].book?.author,
        published: new Date(data.items[i].book?.publicationDate).toLocaleDateString(),
        quantity: data.items[i].bookCount,
        day: new Date(data.items[i].modDate).toLocaleString(),
        name: data.items[i].writer.name,
        phone: data.items[i].phone,
        email: data.items[i].email,
        college: data.items[i].college,
        department: data.items[i].department,
        address: data.items[i].address,
      };
    }
    setExcelData(dataArray);
    setExcelLoading('(준비완료)');
  };

  // AdminSampleBook 리턴값
  return (
    <main className="wrapper list sample-book">
      <div className="title">
        <h1>견본도서 신청현황</h1>
        <div className="buttons">
          <button type="button" onClick={onClickExcel}>
            엑셀파일로 저장 {excelLoading}
          </button>
        </div>
      </div>
      <div className="content">
        <div className="table-header">
          <div className="search">
            <div className="selectbox">
              <select
                name=""
                id=""
                onChange={(event) => {
                  setSearchSelect(event.target.value);
                }}
              >
                {options.map((it) => (
                  <option value={it.value} key={it.value}>
                    {it.name}
                  </option>
                ))}
              </select>
            </div>
            <input
              type="search"
              onChange={(event) => {
                setSearchText(event.target.value);
              }}
              onKeyDown={(event) => {
                if (event.key === 'Enter') {
                  getAllSampleBook();
                }
              }}
            />
            <svg
              onClick={getAllSampleBook}
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="20"
              viewBox="0 0 24 24"
            >
              <path d="M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z" />
            </svg>
          </div>
        </div>
        <div className="table">
          <ul className="row title">
            <li className="isbn">ISBN</li>
            <li className="book-title">도서명</li>
            <li className="author">저자</li>
            <li className="published">출판일</li>
            <li className="quantity">수량</li>
            <li className="day">요청일</li>
            <li className="status">상태</li>
          </ul>
          {/* ↓ 반복되는 데이터 */}
          {rowData()}
        </div>
        {pageInfo ? (
          <Pagenation PageInfo={pageInfo} PagenationHandler={onClickPage} IsFirstEndArrow />
        ) : (
          ''
        )}
      </div>
    </main>
  );
}
